// Barra do Governo Federal — gov.br
// Executado com `defer`, portanto o DOM já está pronto. Sem DOMContentLoaded.
;(function () {
  var nav = document.getElementById('menu-barra-brasil');
  if (!nav || nav._barraInit) return;
  nav._barraInit = true; // guard contra dupla execução (webpack bundle + tag direta)

  var btnOrgaos = document.getElementById('link-orgaos');
  var orgaosPanel = document.getElementById('orgaos-governo-barra');

  function toggleOrgaosGoverno() {
    if (!orgaosPanel || !btnOrgaos) return;
    var isOpen = orgaosPanel.classList.contains('mostra-orgaos');
    var links = nav.querySelectorAll('.link-externo-barra');

    if (isOpen) {
      orgaosPanel.classList.remove('mostra-orgaos');
      orgaosPanel.setAttribute('aria-hidden', 'true');
      btnOrgaos.setAttribute('aria-expanded', 'false');
      btnOrgaos.classList.remove('link-cima-barra');
      links.forEach(function (l) { l.classList.remove('link-discreto-fixo'); });
    } else {
      orgaosPanel.classList.add('mostra-orgaos');
      orgaosPanel.setAttribute('aria-hidden', 'false');
      btnOrgaos.setAttribute('aria-expanded', 'true');
      btnOrgaos.classList.add('link-cima-barra');
      links.forEach(function (l) { l.classList.add('link-discreto-fixo'); });
    }
  }

  if (btnOrgaos) btnOrgaos.addEventListener('click', toggleOrgaosGoverno);
}());
